// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"59187cc4","453":"68693753","610":"edb52677","620":"57e9c903","791":"1d7211b4","934":"351c0e17"}[chunkId] + ".chunk.js";
};